import Pricing from 'components/Pricing/PricingCalculator/SingleProduct.tsx';
import SuppressionRules from "../../../../contents/docs/error-tracking/_snippets/suppression-rules.mdx";
import BurstProtection from "../../../../contents/docs/error-tracking/_snippets/burst-protection.mdx";
import BeforeSendHook from "../../../../contents/docs/error-tracking/_snippets/before-send-hook.mdx";
import * as React from 'react';
export default {
  Pricing,
  SuppressionRules,
  BurstProtection,
  BeforeSendHook,
  React
};